<script setup lang="ts">
import type { BaseAccordionPanel } from '~/components/base/BaseAccordion/baseAccordionTypes';
import type { FooterCategoryColumn } from '~/types/footer';

const props = defineProps<{
  data: FooterCategoryColumn[];
}>();

const { isDesktop } = useGetDevice();

const desktopLayoutComponent = defineAsyncComponent(
  () => import('./AppFooterCategoriesDesktopLayout.vue'),
);
const mobileLayoutComponent = defineAsyncComponent(
  () => import('~/components/base/BaseAccordion/BaseAccordion.vue'),
);

const layoutComponent = computed(() => {
  if (isDesktop.value) {
    return desktopLayoutComponent;
  } else {
    return mobileLayoutComponent;
  }
});

const layoutData = computed(() => {
  if (isDesktop.value) {
    return props.data;
  } else {
    return props.data.flatMap((column) => column.categories);
  }
});
</script>

<template>
  <div class="flex w-full justify-center bg-grey-50">
    <nav
      class="grid w-full max-w-[--max-content-width] auto-rows-auto grid-cols-[repeat(auto-fit,minmax(10rem,1fr))] gap-x-6 px-[--horizontal-layout-padding] pb-20 pt-12 text-t5 md:block md:px-0 md:py-10"
      :aria-label="$t('navigation.footer')"
    >
      <component
        :is="layoutComponent"
        :data="
          layoutData as typeof layoutData.value extends FooterCategoryColumn[]
            ? FooterCategoryColumn[]
            : BaseAccordionPanel[]
        "
      />
    </nav>
  </div>
</template>
